import { MouseEvent } from 'react';

import Icon, { IconName } from '~/src/common/components/Icon';
import { useFeatureFlag } from '~/src/common/services/FeatureFlag';

import * as S from './layout';

type Props = {
  icon: IconName;
  label: string;
  handleClick?: (e: MouseEvent) => void;
};

const MyProductsFocusButton = (props: Props) => {
  const isNewFocus = useFeatureFlag('configuration-page-produit') !== 'old';

  return (
    <S.FocusButtonContainer $isNewFocus={isNewFocus} onClick={props.handleClick}>
      <Icon name={props.icon} />
      <label>{props.label}</label>
    </S.FocusButtonContainer>
  );
};

export default MyProductsFocusButton;
